import React from 'react';
import { DiscountStatus } from './ui/DiscountStatus';
import { DiscountNoOfUses } from './ui/DiscountNoOfUses';
import { DiscountTypeOnListItems } from './ui/DiscountTypeOnListItems';
import { toLocalDate } from '../../yoello-lib/modules/utils/TimeConversion';
import { IDiscountType } from '../../interfaces/IDiscounts';
export const discountsColumns = [
    {
        key: "code", label: 'discounts.columns.code'
    },
    {
        key: "created_on", label: 'discounts.columns.createdDate',
        componentTransform: (date: string, key: any) => {
            return <span key={`${key}-date`}>{toLocalDate(date)}</span>
        }
    },
    {
        key: "type", label: 'discounts.columns.discountType',
        componentTransform: (type: any, key: any) => {
            return <DiscountTypeOnListItems type={type} key={key} />
        }
    },
    {
        key: "value", label: 'discounts.columns.discountValue',
        componentTransform: (value: any, key: any, props: any) => {
            return <span key={`${key}-value`}>{props.type === IDiscountType.VALUE ? value / 100 : value}</span>;
        },
    },
    {
        key: "max_number_of_uses", label: 'discounts.columns.noOfUses',
        componentTransform: (max: any, key: any, props: any) => {
            return <DiscountNoOfUses max={max} NoOfUses={props.number_of_uses} key={key} />;
        },
    },
    {
        key: "enabled", label: '',
        componentTransform: (enabled: any, key: any) => {
            return <DiscountStatus enabled={enabled} key={key} />;
        },
    },
];